import CustomCardComponent from '../SubComponent/CustomCardComponent';
import { SUGGESTION_MODEL_CONTENT } from '../SubComponent/Models/Models';
import {useTranslation} from 'react-i18next';
import {useParams} from "react-router-dom";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const FaceValidationSuggestions = () => {
    const { t } = useTranslation();
    const { guardFlowId } = useParams();

    return (
        <div className="row mt-4 mt-md-0 modal-suggestions-external">
            {SUGGESTION_MODEL_CONTENT.FACE_VALIDATION_SELFIE(guardFlowId).map(({ number, title, subtitle, Icon }) => (
                <div key={number} className="col-12 col-md-6 pb-2">
                    <CustomCardComponent
                        number={number}
                        title={t(title)}
                        subtitle={t(subtitle)}
                        Icon={Icon}
                    />
                </div>
            ))}
        </div>
    );

}

export default FaceValidationSuggestions
